/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { GetSegmentInfoResponseDto } from 'customer-speed-api';
import { EConflictDialogResult } from '../../models';
import { TOverrideConflictSource } from '../../store/actions/manage-posted-speed.actions';

@Component({
  selector: 'fm-override-conflict-dialog',
  templateUrl: './override-conflict-dialog.component.html',
  styleUrls: ['./override-conflict-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverrideConflictDialogComponent {
  public readonly isSaveConflict: boolean;

  constructor(
    public dialogRef: MatLegacyDialogRef<OverrideConflictDialogComponent>,
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: { segmentInfo: GetSegmentInfoResponseDto; source?: TOverrideConflictSource }
  ) {
    this.isSaveConflict = data.source === 'save';
  }

  onCancel(): void {
    this.dialogRef.close(EConflictDialogResult.Cancel);
  }

  onViewUpdate(): void {
    this.dialogRef.close(EConflictDialogResult.Manage);
  }
}
